import { render, staticRenderFns } from "./LoyaltyLogo.vue?vue&type=template&id=0b5aab4e&scoped=true"
import script from "./LoyaltyLogo.vue?vue&type=script&lang=js"
export * from "./LoyaltyLogo.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyLogo.vue?vue&type=style&index=0&id=0b5aab4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5aab4e",
  null
  
)

export default component.exports